











import {Component, Prop, Vue} from "vue-property-decorator";
import RhizomeCloudStatic from "@/modules/Rhizome/components/RhizomeCloudStatic.vue";

@Component({
  components: {
    RhizomeCloudStatic,
  }
})

export default class HeroRhizome extends Vue {
  baseUrl = process.env.VUE_APP_PUBLIC_URL;

  @Prop() item;
}
